export const EDITOR_CONFIG = {
  maxWidth: '960px',
  articleMaxWidth: '720px',
  mediaMaxWidth: '408px',
  px: { base: '40px', md: '100px', lg: '250px' },
};
